// import React, { useState, useEffect } from 'react';
// import { Upload, Download, AlertCircle, CheckCircle, X, HelpCircle } from 'lucide-react';
// import api from '../../api/client';
// import './BulkStockUpload.css';

// function BulkStockUpload({ onClose, onUploadSuccess }) {
//   const [file, setFile] = useState(null);
//   const [uploading, setUploading] = useState(false);
//   const [result, setResult] = useState(null);
//   const [error, setError] = useState(null);
//   const [uploadMode, setUploadMode] = useState('update');

//   const [warehouses, setWarehouses] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Fetch warehouses & products
//   useEffect(() => {
//     fetchOrganizationData();
//   }, []);

//   const fetchOrganizationData = async () => {
//     try {
//       setLoading(true);

//       const warehousesResponse = await api.get('/warehouses/');
//       const warehouseData = warehousesResponse.data;
//       setWarehouses(
//         Array.isArray(warehouseData)
//           ? warehouseData
//           : warehouseData?.results || warehouseData?.warehouses || []
//       );

//       const productsResponse = await api.get('/products/');
//       const productData = productsResponse.data;
//       setProducts(
//         Array.isArray(productData)
//           ? productData
//           : productData?.results || productData?.products || []
//       );

//     } catch (err) {
//       console.error('Failed to fetch organization data:', err);
//       setError('Failed to load your organization data');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleFileChange = (e) => {
//     const selectedFile = e.target.files[0];
//     if (!selectedFile) return;

//     if (!selectedFile.name.endsWith('.csv')) {
//       setError('Please select a CSV file');
//       return;
//     }
//     setFile(selectedFile);
//     setError(null);
//     setResult(null);
//   };

//   const handleUpload = async () => {
//     if (!file) {
//       setError('Please select a file first');
//       return;
//     }

//     setUploading(true);
//     setError(null);
//     setResult(null);

//     const formData = new FormData();
//     formData.append('file', file);

//     try {
//       const response = await api.post('/bulk-stock-upload/', formData, {
//         headers: { 'Content-Type': 'multipart/form-data' },
//       });

//       setResult(response.data);

//       if (response.data.success_count > 0 && onUploadSuccess) {
//         onUploadSuccess();
//       }
//     } catch (err) {
//       setError(err.response?.data?.error || 'Upload failed');
//     } finally {
//       setUploading(false);
//     }
//   };

//   // CSV template generator - safe version
//   const downloadTemplate = () => {
//     let template;
//     let filename;

//     if (uploadMode === 'update') {
//       if (!Array.isArray(products) || products.length === 0) {
//         setError('No products found. Please create products first.');
//         return;
//       }

//       const sampleProducts = products.slice(0, 3);
//       const sampleWarehouse =
//         Array.isArray(warehouses) && warehouses.length > 0
//           ? warehouses[0].name
//           : 'Your Warehouse Name';

//       template = `product_sku,warehouse_name,quantity,reorder_level\n`;

//       sampleProducts.forEach(product => {
//         template += `${product.sku || ''},${sampleWarehouse},100,20\n`;
//       });

//       filename = 'stock_update_template.csv';

//     } else {
//       if (!Array.isArray(warehouses) || warehouses.length === 0) {
//         setError('No warehouses found. Please create at least one warehouse first.');
//         return;
//       }

//       const sampleWarehouse = warehouses[0]?.name || 'Your Warehouse Name';

//       template = `product_name,product_category,warehouse_name,quantity,reorder_level,cost_price,selling_price
// Batik Fabric,Textiles,${sampleWarehouse},100,20,15.00,25.00
// Kente Cloth,Textiles,${sampleWarehouse},50,10,12.00,20.00
// Argan Oil 100ml,Cosmetics,${sampleWarehouse},75,15,8.00,15.00`;

//       filename = 'product_and_stock_template.csv';
//     }

//     const blob = new Blob([template], { type: 'text/csv' });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = filename;
//     a.click();
//     window.URL.revokeObjectURL(url);
//   };

//   if (loading) {
//     return (
//       <div className="bulk-upload-overlay">
//         <div className="bulk-upload-modal">
//           <div className="bulk-upload-header">
//             <h3>Bulk Stock Upload</h3>
//             <button onClick={onClose} className="close-btn">
//               <X size={24} />
//             </button>
//           </div>
//           <div className="bulk-upload-content">
//             <div style={{ textAlign: 'center', padding: '40px' }}>
//               <div className="spinner"></div>
//               <p>Loading your organization data...</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   const hasWarehouses = Array.isArray(warehouses) && warehouses.length > 0;
//   const hasProducts = Array.isArray(products) && products.length > 0;

//   return (
//     <div className="bulk-upload-overlay">
//       <div className="bulk-upload-modal">
//         <div className="bulk-upload-header">
//           <h3>Bulk Stock Upload</h3>
//           <button onClick={onClose} className="close-btn">
//             <X size={24} />
//           </button>
//         </div>

//         <div className="bulk-upload-content">

//           {/* Alerts */}
//           {!hasWarehouses && (
//             <div className="alert alert-warning">
//               <AlertCircle size={20} />
//               <div>
//                 <strong>No warehouses found!</strong>
//                 <p>Please create at least one warehouse before uploading stock data.</p>
//               </div>
//             </div>
//           )}

//           {uploadMode === 'update' && !hasProducts && (
//             <div className="alert alert-warning">
//               <AlertCircle size={20} />
//               <div>
//                 <strong>No products found!</strong>
//                 <p>You need existing products to update stock.</p>
//               </div>
//             </div>
//           )}

//           {/* Mode selection */}
//           <div className="upload-mode-selector">
//             <h4>Choose Upload Type</h4>

//             <div className="mode-options">

//               <label className={`mode-option ${uploadMode === 'update' ? 'active' : ''} ${!hasProducts ? 'disabled' : ''}`}>
//                 <input
//                   type="radio"
//                   name="uploadMode"
//                   value="update"
//                   checked={uploadMode === 'update'}
//                   onChange={(e) => setUploadMode(e.target.value)}
//                   disabled={!hasProducts}
//                 />
//                 <div className="mode-content">
//                   <strong>Update Stock Quantities</strong>
//                   <p>Existing products ({products.length})</p>
//                 </div>
//               </label>

//               <label className={`mode-option ${uploadMode === 'create' ? 'active' : ''}`}>
//                 <input
//                   type="radio"
//                   name="uploadMode"
//                   value="create"
//                   checked={uploadMode === 'create'}
//                   onChange={(e) => setUploadMode(e.target.value)}
//                 />
//                 <div className="mode-content">
//                   <strong>Create New Products + Stock</strong>
//                   <p>SKU auto-generated</p>
//                 </div>
//               </label>

//             </div>
//           </div>

//           {/* Warehouse list */}
//           {hasWarehouses && (
//             <div className="warehouse-info">
//               <h4>Your Warehouses:</h4>
//               <div className="warehouse-chips">
//                 {Array.isArray(warehouses) &&
//                   warehouses.map(w => (
//                     <span key={w.id} className="warehouse-chip">
//                       {w.name}
//                     </span>
//                   ))}
//               </div>
//             </div>
//           )}

//           {/* Instructions */}
//           <div className="upload-instructions">
//             <h4>Instructions:</h4>

//             <button
//               onClick={downloadTemplate}
//               className="btn-template"
//               disabled={!hasWarehouses || (uploadMode === 'update' && !hasProducts)}
//             >
//               <Download size={20} />
//               {uploadMode === 'update'
//                 ? 'Download Stock Update Template'
//                 : 'Download New Products Template'}
//             </button>
//           </div>

//           {/* File upload */}
//           <div className="file-upload-section">
//             <label htmlFor="csv-file" className="file-label">
//               <Upload size={24} />
//               <span>Choose CSV File</span>
//               <input
//                 id="csv-file"
//                 type="file"
//                 accept=".csv"
//                 onChange={handleFileChange}
//                 style={{ display: 'none' }}
//                 disabled={!hasWarehouses}
//               />
//             </label>

//             {file && (
//               <div className="file-selected">
//                 <CheckCircle size={20} />
//                 <span>{file.name}</span>
//               </div>
//             )}

//             <button
//               onClick={handleUpload}
//               disabled={!file || uploading || !hasWarehouses}
//               className="btn-upload"
//             >
//               {uploading ? 'Uploading...' : 'Upload Stock Data'}
//             </button>
//           </div>

//           {/* Error */}
//           {error && (
//             <div className="alert alert-error">
//               <AlertCircle size={20} />
//               <span>{error}</span>
//             </div>
//           )}

//           {/* Result */}
//           {result && (
//             <div className="upload-result">

//               <div className="result-summary">
//                 <div className="result-item success">
//                   <CheckCircle size={24} />
//                   <strong>{result.success_count}</strong> Successful
//                 </div>

//                 <div className="result-item error">
//                   <AlertCircle size={24} />
//                   <strong>{result.error_count}</strong> Errors
//                 </div>
//               </div>

//               {Array.isArray(result.created_products) && result.created_products.length > 0 && (
//                 <div className="created-products-info">
//                   <h4>Created Products:</h4>
//                   <ul>
//                     {result.created_products.map((name, idx) => (
//                       <li key={idx}>{name}</li>
//                     ))}
//                   </ul>
//                 </div>
//               )}

//               {Array.isArray(result.errors) && result.errors.length > 0 && (
//                 <div className="error-details">
//                   <h4>Errors:</h4>
//                   <ul>
//                     {result.errors.map((err, idx) => (
//                       <li key={idx}>{err}</li>
//                     ))}
//                   </ul>
//                 </div>
//               )}
//             </div>
//           )}

//           {/* CSV Format */}
//           <div className="csv-format-help">
//             <h4>CSV Format:</h4>

//             {uploadMode === 'create' ? (
//               <ul>
//                 <li>
//                   <strong>warehouse_name:</strong> Must match one of:{' '}
//                   {Array.isArray(warehouses)
//                     ? warehouses.map(w => w.name).join(', ')
//                     : 'None'}
//                 </li>
//               </ul>
//             ) : (
//               <ul>
//                 <li><strong>product_sku:</strong> Must match one of your existing products</li>
//               </ul>
//             )}

//           </div>

//         </div>
//       </div>
//     </div>
//   );
// }

// export default BulkStockUpload;


import React, { useState, useEffect } from 'react';
import { Upload, Download, AlertCircle, CheckCircle, X } from 'lucide-react';
import Papa from 'papaparse';
import api from '../../api/client';
import './BulkStockUpload.css';

function BulkStockUpload({ onClose, onUploadSuccess }) {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [uploadMode, setUploadMode] = useState('update');
  const [warehouses, setWarehouses] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrganizationData();
  }, []);

  const fetchOrganizationData = async () => {
    try {
      setLoading(true);
      const [warehousesResponse, productsResponse] = await Promise.all([
        api.get('/warehouses/'),
        api.get('/products/')
      ]);
      
      setWarehouses(Array.isArray(warehousesResponse.data) ? warehousesResponse.data : warehousesResponse.data?.results || []);
      setProducts(Array.isArray(productsResponse.data) ? productsResponse.data : productsResponse.data?.results || []);
    } catch (err) {
      setError('Failed to load organization data');
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    if (!selectedFile.name.endsWith('.csv')) {
      setError('Please select a CSV file');
      return;
    }
    
    setFile(selectedFile);
    setError(null);
    setResult(null);
    
    // Parse and preview first 5 rows
    Papa.parse(selectedFile, {
      header: true,
      preview: 5,
      skipEmptyLines: true,
      complete: (results) => {
        setPreview(results.data);
      },
      error: (error) => {
        setError('Failed to parse CSV: ' + error.message);
      }
    });
  };

  const handleUpload = async () => {
    if (!file) {
      setError('Please select a file first');
      return;
    }

    setUploading(true);
    setError(null);
    setResult(null);

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await api.post('/bulk-stock-upload/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      setResult(response.data);
      setPreview([]); // Clear preview after upload

      if (response.data.success_count > 0 && onUploadSuccess) {
        onUploadSuccess();
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  const downloadTemplate = () => {
    let template;
    let filename;

    if (uploadMode === 'update') {
      if (!products.length) {
        setError('No products found. Please create products first.');
        return;
      }

      const sampleProducts = products.slice(0, 3);
      const sampleWarehouse = warehouses.length > 0 ? warehouses[0].name : 'Main Warehouse';

      template = `product_sku,warehouse_name,quantity,reorder_level\n`;
      sampleProducts.forEach(product => {
        template += `${product.sku || ''},${sampleWarehouse},100,20\n`;
      });

      filename = 'stock_update_template.csv';
    } else {
      const sampleWarehouse = warehouses.length > 0 ? warehouses[0].name : 'Main Warehouse';

      template = `product_name,product_category,warehouse_name,quantity,reorder_level,cost_price,selling_price
Batik Fabric,Textiles,${sampleWarehouse},100,20,15.00,25.00
Kente Cloth,Textiles,${sampleWarehouse},50,10,12.00,20.00
Argan Oil 100ml,Cosmetics,${sampleWarehouse},75,15,8.00,15.00`;

      filename = 'product_and_stock_template.csv';
    }

    const blob = new Blob([template], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  if (loading) {
    return (
      <div className="bulk-upload-overlay">
        <div className="bulk-upload-modal">
          <div className="bulk-upload-header">
            <h3>Bulk Stock Upload</h3>
            <button onClick={onClose} className="close-btn">
              <X size={24} />
            </button>
          </div>
          <div className="bulk-upload-content" style={{ textAlign: 'center', padding: '40px' }}>
            <div className="spinner"></div>
            <p>Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bulk-upload-overlay">
      <div className="bulk-upload-modal">
        <div className="bulk-upload-header">
          <h3>Bulk Stock Upload</h3>
          <button onClick={onClose} className="close-btn">
            <X size={24} />
          </button>
        </div>

        <div className="bulk-upload-content">
          {!warehouses.length && (
            <div className="alert alert-warning">
              <AlertCircle size={20} />
              <span>No warehouses found! Please create at least one warehouse first.</span>
            </div>
          )}

          {uploadMode === 'update' && !products.length && (
            <div className="alert alert-warning">
              <AlertCircle size={20} />
              <span>No products found! You need existing products to update stock.</span>
            </div>
          )}

          {/* Mode Selection */}
          <div className="upload-mode-selector">
            <h4>Choose Upload Type</h4>
            <div className="mode-options">
              <label className={`mode-option ${uploadMode === 'update' ? 'active' : ''} ${!products.length ? 'disabled' : ''}`}>
                <input
                  type="radio"
                  name="uploadMode"
                  value="update"
                  checked={uploadMode === 'update'}
                  onChange={(e) => setUploadMode(e.target.value)}
                  disabled={!products.length}
                />
                <div>
                  <strong>Update Stock Quantities</strong>
                  <p>For existing products ({products.length})</p>
                </div>
              </label>

              <label className={`mode-option ${uploadMode === 'create' ? 'active' : ''}`}>
                <input
                  type="radio"
                  name="uploadMode"
                  value="create"
                  checked={uploadMode === 'create'}
                  onChange={(e) => setUploadMode(e.target.value)}
                />
                <div>
                  <strong>Create New Products + Stock</strong>
                  <p>SKU auto-generated</p>
                </div>
              </label>
            </div>
          </div>

          {/* Template Download */}
          <div className="upload-instructions">
            <h4>Instructions:</h4>
            <button
              onClick={downloadTemplate}
              className="btn-template"
              disabled={!warehouses.length || (uploadMode === 'update' && !products.length)}
            >
              <Download size={20} />
              {uploadMode === 'update' ? 'Download Stock Update Template' : 'Download New Products Template'}
            </button>
          </div>

          {/* File Upload */}
          <div className="file-upload-section">
            <label htmlFor="csv-file" className="file-label">
              <Upload size={24} />
              <span>Choose CSV File</span>
              <input
                id="csv-file"
                type="file"
                accept=".csv"
                onChange={handleFileChange}
                style={{ display: 'none' }}
                disabled={!warehouses.length}
              />
            </label>

            {file && (
              <div className="file-selected">
                <CheckCircle size={20} />
                <span>{file.name}</span>
              </div>
            )}
          </div>

          {/* Preview */}
          {preview.length > 0 && (
            <div className="preview-section">
              <h3>📊 Preview (first 5 rows)</h3>
              <div className="preview-table-wrapper">
                <table className="preview-table">
                  <thead>
                    <tr>
                      {uploadMode === 'create' ? (
                        <>
                          <th>Product Name</th>
                          <th>Category</th>
                          <th>Warehouse</th>
                          <th>Quantity</th>
                          <th>Cost Price</th>
                          <th>Selling Price</th>
                        </>
                      ) : (
                        <>
                          <th>Product SKU</th>
                          <th>Warehouse</th>
                          <th>Quantity</th>
                          <th>Reorder Level</th>
                        </>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {preview.map((row, i) => (
                      <tr key={i}>
                        {uploadMode === 'create' ? (
                          <>
                            <td>{row.product_name || '—'}</td>
                            <td>{row.product_category || 'Other'}</td>
                            <td>{row.warehouse_name || '—'}</td>
                            <td>{row.quantity || 0}</td>
                            <td>TSh {row.cost_price || '0.00'}</td>
                            <td>TSh {row.selling_price || '0.00'}</td>
                          </>
                        ) : (
                          <>
                            <td>{row.product_sku || '—'}</td>
                            <td>{row.warehouse_name || '—'}</td>
                            <td>{row.quantity || 0}</td>
                            <td>{row.reorder_level || 10}</td>
                          </>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Upload Button */}
          {file && !result && (
            <button
              onClick={handleUpload}
              disabled={uploading || !warehouses.length}
              className="btn-upload"
            >
              {uploading ? 'Uploading...' : '📤 Upload Stock Data'}
            </button>
          )}

          {/* Error */}
          {error && (
            <div className="alert alert-error">
              <AlertCircle size={20} />
              <span>{error}</span>
            </div>
          )}

          {/* Result */}
          {result && (
            <div className="upload-result">
              <div className="result-summary">
                <div className="result-item success">
                  <CheckCircle size={24} />
                  <strong>{result.success_count}</strong> Successful
                </div>
                <div className="result-item error">
                  <AlertCircle size={24} />
                  <strong>{result.error_count}</strong> Errors
                </div>
              </div>

              {result.created_products?.length > 0 && (
                <div className="created-products-info">
                  <h4>Created Products:</h4>
                  <ul>
                    {result.created_products.map((name, idx) => (
                      <li key={idx}>{name}</li>
                    ))}
                  </ul>
                </div>
              )}

              {result.errors?.length > 0 && (
                <div className="error-details">
                  <h4>Errors:</h4>
                  <ul>
                    {result.errors.map((err, idx) => (
                      <li key={idx}>{err}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default BulkStockUpload;
